import {
  ChangeDetectionStrategy,
  Component,
  InputSignal,
  ModelSignal,
  Signal,
  computed,
  input,
  model,
} from '@angular/core';

import { ListActionButtonComponent } from '../list-action-button/list-action-button.component';

@Component({
  selector: 'mp-show-all-options-button',
  templateUrl: './show-all-options-button.component.html',
  styleUrl: './show-all-options-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.mp-show-all-options-button--no-collapsed-elements]': '!collapsedItemsCount()',
  },
  imports: [ListActionButtonComponent],
})
export class ShowAllOptionsButtonComponent {
  readonly totalItemsCount: InputSignal<number> = input<number>(1);

  readonly maxVisibleItemsCount: InputSignal<number> = input<number>(0);

  readonly showAll: ModelSignal<boolean> = model<boolean>(false);

  protected readonly collapsedItemsCount: Signal<number> = computed(() =>
    Math.max(this.totalItemsCount() - this.maxVisibleItemsCount(), 0),
  );

  protected readonly buttonLabel: Signal<string> = computed(() => {
    if (this.showAll()) {
      return 'WENIGER ANZEIGEN';
    }

    return `${this.collapsedItemsCount()} WEITERE`;
  });

  toggleShowAll(): void {
    this.showAll.set(!this.showAll());
  }
}
